import { Button, Container, Heading, Stack, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateTeam } from '../../../reducers/useReducers';
import Backend from './Backend';
import Frontend from './Frontend';
import GameDev from './GameDev';
import Marketing from './Marketing';
import MobileApp from './MobileApp';
import Danish from '../../../assets/images/teams/danish.png'
import Hasan from '../../../assets/images/teams/hasan.png'
import Safeer from '../../../assets/images/teams/safeer.png'
import Saqib from '../../../assets/images/teams/saqib.png'
import Amir from '../../../assets/images/teams/amir.png'
import Faisal from '../../../assets/images/teams/faisal.png'
import Ali from '../../../assets/images/teams/ali.png'
import Maroof from '../../../assets/images/teams/maroof.png'
import Alishiwani from '../../../assets/images/teams/Alishiwani.png'
import Ashir from '../../../assets/images/teams/Ashir.png'
import Shah from '../../../assets/images/teams/Shah.png'
import Rafay from '../../../assets/images/teams/rafay.png'
import Bilal from '../../../assets/images/teams/bilal.png'
import Zaydi from '../../../assets/images/teams/zaydi.png'
import Taha from '../../../assets/images/teams/taha.png'
import Kizar from '../../../assets/images/teams/kizar.png'

import Suraj from '../../../assets/images/teams/suraj.png'
import Minhaj from '../../../assets/images/teams/minhaj.png'
import Fawad from '../../../assets/images/teams/fawad.png'
import Rizvi from '../../../assets/images/teams/Rizvi.png'
import Rafaymobile from '../../../assets/images/teams/rafaymobile.png'
import Raza from '../../../assets/images/teams/Raza.png'
import Raveda from '../../../assets/images/teams/raveda.png'



import Daniyal from '../../../assets/images/teams/marketing/daniyal.png'
import Kashif from '../../../assets/images/teams/marketing/Kashif.png'
import osama from '../../../assets/images/teams/marketing/osama.png'
import SyedFaizan  from '../../../assets/images/teams/marketing/SyedFaizan.png'
import Asad from '../../../assets/images/teams/marketing/Asad.png'
import Furkan  from '../../../assets/images/teams/marketing/Furkan.png'
import Umer  from '../../../assets/images/teams/marketing/Umer.png'
 
import Sheryar from '../../../assets/images/teams/marketing/Sheryar.png'
import usama from '../../../assets/images/teams/marketing/usama.png'
import Nimra from '../../../assets/images/teams/marketing/Nimra.png'
import Fatima from '../../../assets/images/teams/marketing/Fatima.png'
import Anusha from '../../../assets/images/teams/marketing/Anusha.png'
import Graphicsdesign from './Graphicsdesign';

import UzairSultan from '../../../assets/images/teams/Graphics/UzairSultan.png'
import Owais from '../../../assets/images/teams/Graphics/Owais.png'
import Ekrama from '../../../assets/images/teams/Graphics/Ekrama.png'
import Khwaja from '../../../assets/images/teams/Graphics/Khwaja.png'
import Aishaayub from '../../../assets/images/teams/Graphics/Aishaayub.png'
import Managment from './Managment';


import Iqra from '../../../assets/images/teams/management/iqra.png'
import Farhan from '../../../assets/images/teams/management/farhan.png'
import jehangir from '../../../assets/images/teams/management/jehangir.png'
import quratulain from '../../../assets/images/teams/management/Quratulain.png'
import saad from '../../../assets/images/teams/management/saad.png'
import saqib from '../../../assets/images/teams/management/saqib.png'
import Muzair from '../../../assets/images/teams/management/Muzair.png'

import Ahraz from '../../../assets/images/teams/Games/Ahraz.png'
import Irfan from '../../../assets/images/teams/Games/Irfan.png'
import Ishaq from '../../../assets/images/teams/Games/Ishaq.png'
import Obaid from '../../../assets/images/teams/Games/Obaid.png'


export default function AllTeams() {

    const dispatch = useDispatch();
    const currentTeam = useSelector(state => state.team)
    const [TeamsButtons] = useState(['Frontend', 'Backend','Graphics Design','Mobile App', 'Marketing','Management', 'Game Dev']);

    const [GameTeam] = useState([
        {
            image: Ishaq,
            name: 'Ishaq Patni',
            designation: 'HOD - Gaming & Development',
            linkedinLink: '#',
        },
        {
            image: Ahraz,
            name: 'Syed Ahraz',
            designation: 'Concept Artist',
            linkedinLink: '#',
        },
        {
            image: Irfan,
            name: 'Irfan Ahmed Shah',
            designation: 'Senior Game Artist',
            linkedinLink: '#',
        },
        {
            image: Obaid,
            name: 'Obaid Ahmed',
            designation: 'Senior Motion Graphic Artist',
            linkedinLink: '#',
        },
       
    ]);
    const [ManagementTeam] = useState([
        {
            image: Farhan,
            name: 'Farhan A Bukhsh',
            designation: 'Head Of IT & Networking',
            linkedinLink: '#',
        },
        {
            image: Iqra,
            name: 'Iqra Akber',
            designation: 'HR Manager',
            linkedinLink: '#',
        },
        {
            image: jehangir,
            name: 'Jehangir Khan',
            designation: 'IT Officer',
            linkedinLink: '#',
        },
       
        {
            image: quratulain,
            name: 'Quratulain',
            designation: 'HR Manager',
            linkedinLink: '#',
        },
        {
            image: saad,
            name: 'Muhammad Saad',
            designation: 'Junior Finance Officer',
            linkedinLink: '#',
        },
        {
            image: saqib,
            name: 'Muhammad Saqib',
            designation: 'Admin Manger',
            linkedinLink: '#',
        },
        {
            image: Muzair,
            name: 'Muzair Hussain',
            designation: 'Finance Executive',
            linkedinLink: '#',
        },
       
    ]);

    const [GraphicsTeam] = useState([
        {
            image: UzairSultan,
            name: 'Uzair Sultan',
            designation: 'Lead Graphic Designer',
            linkedinLink: '#',
        },
        {
            image: Owais,
            name: 'Owais Mirza',
            designation: 'Senior Graphic Designer',
            linkedinLink: '#',
        },
        {
            image: Aishaayub,
            name: 'Aisha Ayub',
            designation: 'UI/UX Graphic Designer',
            linkedinLink: '#',
        },
       
        {
            image: Ekrama,
            name: 'Ekrama Hussain',
            designation: 'Associate Graphic Designer',
            linkedinLink: '#',
        },
        {
            image: Khwaja,
            name: 'Khwaja Umair Hussain',
            designation: 'Associate Graphic Designer',
            linkedinLink: '#',
        },
       
    ]);
    const [MarketingTeam] = useState([
        {
            image: Daniyal,
            name: 'Daniyal Abid Khatib',
            designation: 'IDA / Sales & Marketing',
            linkedinLink: '#',
        },
        {
            image: Kashif,
            name: 'Kashif Shayari',
            designation: 'Project Manager',
            linkedinLink: '#',
        },
        {
            image: osama,
            name: 'Muhammad Usama',
            designation: 'Team Lead PPC',
            linkedinLink: '#',
        },
        {
            image: SyedFaizan,
            name: 'Syed Faizan',
            designation: 'Team Lead PPC',
            linkedinLink: '#',
        },
        {
            image: Asad,
            name: 'Asad Ullah Pervaiz',
            designation: 'Data Entry Operator',
            linkedinLink: '#',
        },
        {
            image: Furkan,
            name: 'Furkan Khan',
            designation: 'Data Entry Operator',
            linkedinLink: '#',
        },
        {
            image: Umer,
            name: 'Muhammad Umer Iqbal',
            designation: 'PPC Executive',
            linkedinLink: '#',
        },
     
        {
            image: Sheryar,
            name: 'Sheryar Raza',
            designation: 'Business Development Manaer',
            linkedinLink: '#',
        },
        {
            image: usama,
            name: 'Muhammad Usman',
            designation: 'Product Manager',
            linkedinLink: '#',
        },
        {
            image: Nimra,
            name: 'Nimra Tariq',
            designation: 'Business Development Executive',
            linkedinLink: '#',
        },
        {
            image: Fatima,
            name: 'Fatima Raza',
            designation: 'Manager Creative Writer',
            linkedinLink: '#',
        },
        {
            image: Anusha,
            name: 'Anusha Ather',
            designation: 'Senior Content Writer',
            linkedinLink: '#',
        },
       
    ]);
    const [FrontendTeam] = useState([
        {
            image: Danish,
            name: 'Danish Patel',
            designation: 'Lead UI/UX | React Web App Developer',
            linkedinLink: '#',
        },
        {
            image: Hasan,
            name: 'Muhammad Hasan',
            designation: 'Senior UI/UX Engineer',
            linkedinLink: '#',
        },
        {
            image: Safeer,
            name: 'Safeer Shaikh',
            designation: 'Associate UI/UX | React Web App Developer',
            linkedinLink: '#',
        },
        {
            image: Saqib,
            name: 'Saquib Saleem',
            designation: 'Associate UI/UX Engineer',
            linkedinLink: '#',
        },
       
    ]);
    const [BackendTeam] = useState([
        {
            image: Ali,
            name: 'Ali Asghar Hussain',
            designation: 'Senior Software Engineer',
            linkedinLink: '#',
        },
        {
            image: Amir,
            name: 'Amir Yaqoob',
            designation: 'Team Lead ERP',
            linkedinLink: '#',
        },
        {
            image: Faisal,
            name: 'Shah Faisal',
            designation: 'Team Lead ERP And BMS',
            linkedinLink: '#',
        },
        {
            image: Maroof,
            name: 'Abdul Maroof Yousfani',
            designation: 'Senior Software Engineer',
            linkedinLink: '#',
        },
        {
            image: Alishiwani,
            name: 'Ali Shiwani',
            designation: 'Senior Laravel Developer',
            linkedinLink: '#',
        },
        {
            image: Ashir,
            name: 'Muhammad Ashir',
            designation: 'Senior Software Developer',
            linkedinLink: '#',
        },
        {
            image: Shah,
            name: 'Syed Muhammad Shah',
            designation: 'Laravel Developer',
            linkedinLink: '#',
        },
        {
            image: Rafay,
            name: 'Muhammad Rafay',
            designation: 'Laravel Developer',
            linkedinLink: '#',
        },
        {
            image: Bilal,
            name: 'Muhammad Bilal',
            designation: 'Senior Backend Developer',
            linkedinLink: '#',
        },
       
        {
            image: Taha,
            name: 'Taha Khan',
            designation: 'Associate Software Developer',
            linkedinLink: '#',
        },
        {
            image: Kizar,
            name: 'Khizar Shafi',
            designation: 'Backend Developer',
            linkedinLink: '#',
        },
        {
            image: Zaydi,
            name: 'Abdullah Zaydi',
            designation: 'Full Stack Developer',
            linkedinLink: '#',
        },
       
    ]);
    const [MobileTeam] = useState([
        {
            image: Suraj,
            name: 'Suraj Kumar',
            designation: 'Team Lead Mobile Development',
            linkedinLink: '#',
        },
       
        {
            image: Minhaj,
            name: 'Minhaj Ali Khan',
            designation: 'Project Manager',
            linkedinLink: '#',
        },
        {
            image: Fawad,
            name: 'Suraj Kumar',
            designation: 'Senior Android Developer',
            linkedinLink: '#',
        },
        {
            image: Rizvi,
            name: 'Bilal Hassan Rizvi',
            designation: 'Senior Flutter Developer',
            linkedinLink: '#',
        },
        {
            image: Rafaymobile,
            name: 'Abdul Rafay',
            designation: 'Senior Flutter Developer',
            linkedinLink: '#',
        },
        {
            image: Raza,
            name: 'Ahmed Raza',
            designation: 'Junior Flutter Developer',
            linkedinLink: '#',
        },
        {
            image: Raveda,
            name: 'Raweeda Kousar',
            designation: 'Android Developer',
            linkedinLink: '#',
        },
       
    ]);

    

    return (
        <Stack
            py={{ base: '30px', lg: '120px' }}
        >
            <Container maxW={{ lg: '6xl', '2xl': '8xl' }}>
                <Heading
                    fontWeight={'600'}
                    color={'primaryOrange.100'}
                    fontSize={{ base: 44, lg: 64 }}
                    pb={{base: '4', lg: '12'}}
                >
                    Creative <Text
                        as={'span'}
                        color={'bgGrays.100'}
                        position={'relative'}
                        w={'fit-content'}
                        fontWeight={'600'}
                        fontStyle={'italic'}
                        _before={{
                            content: '""',
                            position: 'absolute',
                            w: '100%',
                            zIndex: -1,
                            h: { base: '4px', lg: '10px' },
                            bgColor: 'primaryOrange.100',
                            bottom: '15px'
                        }}
                    >
                        Team</Text></Heading>

                <Stack
                    direction={'row'}
                    justifyContent={{base: 'center', lg: 'space-between'}}
                    alignItems={'center'}
                    mb={12}
                    spacing={0}
                    gap={{base: 1, lg: 0}}
                    flexWrap={{ base: 'wrap', lg: 'nowrap' }}
                >
                    {
                        TeamsButtons.map((v, i) =>
                            <Button
                                key={i}
                                onClick={() => dispatch(updateTeam(v))}
                                borderRadius={6}
                                border={'1px solid'}
                                borderColor={currentTeam === v ? 'primaryOrange.100' : 'bgGrays.100'}
                                color={currentTeam === v ? 'white.100' : 'bgGrays.100'}
                                w={{base: '48%', lg: '10%'}}
                                py={'20px'}
                                fontSize={'15px'}
                                fontWeight={400}
                                bgColor={currentTeam === v ? 'primaryOrange.100' : 'white.100'}
                                _hover={{
                                    bgColor: 'primaryOrange.100',
                                    borderColor: 'white.100',
                                    color: 'white.100'
                                }}
                                _focus={{
                                    bgColor: 'primaryOrange.100'
                                }}
                                _active={{
                                    bgColor: 'primaryOrange.100'
                                }}
                            >
                                {v}
                            </Button>
                        )
                    }
                </Stack>

                <Stack mt={'6'}>
                    {
                        currentTeam === 'Frontend' ?
                            <Frontend {...FrontendTeam} />
                            : currentTeam === 'Backend' ?
                                <Backend {...BackendTeam} />
                                : currentTeam === 'Graphics Design' ?
                                <Graphicsdesign {...GraphicsTeam} />
                                : currentTeam === 'Mobile App' ?
                                    <MobileApp {...MobileTeam} />
                                    : currentTeam === 'Marketing' ?
                                        <Marketing {...MarketingTeam} />
                                        : currentTeam === 'Management' ?
                                            <Managment {...ManagementTeam} />
                                            : currentTeam === 'Game Dev' ?
                                                <GameDev {...GameTeam} />
                                                :
                                                <Frontend {...FrontendTeam} />
                    }
                </Stack>

            </Container>
        </Stack>
    )
}
